/**
 * Makes an asynchronous request to a WordPress REST API endpoint.
 */

const makeRequest = async (endpoint, method, body = {}) => {
  const url = qustodioCore.ajaxURL + endpoint;

  const headers = {
    'Content-Type': 'application/json;charset=UTF-8',
    'X-WP-Nonce': qustodioCore.ajaxNonce,
  };

  const response = await fetch(url, {
    method,
    headers,
    body: JSON.stringify(body),
  });

  return response.json();
};

const ajaxRequest = (endpoint) => {
  const post = async (body = {}) => makeRequest(endpoint, 'POST', body);
  const get = async (body = {}) => makeRequest(endpoint, 'GET', body);
  return { post, get };
};

export default ajaxRequest;
